export const PRIMARY_COLOR = "rgb(12, 5, 109)";
export const SECONDARY_COLOR = "rgb(83, 64, 255)";

export const HTTP_STATUS_SUCCESS = 200


export const MSG_CHANGES_SAVED = "Änderungen gespeichert."
export const MSG_CHANGES_NOT_SAVED = "Änderungen nicht gespeichert."
export const MSG_ERROR_OCCURED = "Es trat ein Fehler auf. HTTP-Status-Code: "; 
